export default function() {
  return /^([\( \+]?36|06|0036[\) ]?)?[\-\(\. ]?((1|[2-9]0|31)[\-\)\. ]?([\-\. ]?[0-9]){7}|([\-\(\. ]?[2-9][1-9][\-\)\. ]?)([\-\. ]?[0-9]){6})$/;
};